export const news = [
  {
    id: "n03",
    date: "2026.04.02",
    category: "TECHNOLOGY",
    title: "雷撃カゴ特許出願中、意匠登録済、商標登録済のお知らせ",
    excerpt:
      "雷撃カゴは現在特許出願中であり、意匠登録済です。「雷撃」はハヤブサワークスの登録商標です。",
    image:
      "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/2e538b1020cd0dd3820d39ffbdc1e3e6.jpeg",
    objectPosition: "50% 0%",
  },
  {
    id: "n02",
    date: "2026.05.14",
    category: "NEWS",
    title: "新聞に掲載されました",
    excerpt:
      "オリジナルカゴウキ「雷撃カゴ」が地方紙（山陰中央新報）に掲載されました。",
    image:
      "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/a4cb7e3dcb6b5227e36583d7312da963.png",
    objectPosition: "50% 0%",
  },
  {
    id: "n01",
    date: "2026.06.28",
    category: "FIELD TEST",
    title: "離島スペシャル開発中",
    excerpt:
      "開発中の離島スペシャルでは、100Ｍの飛距離も夢ではありません。",
    image:
      "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/05d85c24a1f24ceb746c3953631fae22.jpeg",
    objectPosition: "50% 50%",
  },
];